import styled from "@emotion/styled";
import Block from "components/layout/block";

export const StyledBlock = styled(Block)`
  margin-top: 2rem;
`;
